import { fromJS, Map } from 'immutable';
import Actions from 'flow/actions';

const initialState = Map();

const retailerReducer = (state = initialState, action) => {
    switch (action ? action.type : null) {
        case Actions.CLEAR_STATE: {
            return initialState;
        }
        case Actions.RESULT_RETAILER_LOGO: {
            return state.set('logo', fromJS(action.data));
        }
        default: {
            return state;
        }
    }
};

export default retailerReducer;
